import Modal from "react-modal";
import { useFilterContext } from "../../contexts/FilterProvider";
import { useAnalytics } from "app/utils/analytics/useAnalytics";
import { Formik } from "formik";
import PropTypes from "prop-types";
import { FilterDrawerForm } from "./FilterDrawerForm";
import "./FilterDrawer.scss";
import useBlockScroll from "app/utils/hooks/useBlockScroll";

export const FilterDrawer = ({ isSinglePanelMode = false, onSubmit, onApply, onChange }) => {
	const { isOpen, closeDrawer, filters, setFilters } = useFilterContext();
	const { track } = useAnalytics();

	useBlockScroll(isOpen);

	const handleSubmit = values => {
		track("product-filter-apply", values);

		setFilters(values);

		if (typeof onSubmit === "function") {
			onSubmit(values);
		}

		closeDrawer();
	};

	return (
		<Modal
			isOpen={isOpen}
			closeTimeoutMS={240}
			onRequestClose={closeDrawer}
			overlayClassName="filter-drawer__overlay"
			className="filter-drawer__content"
		>
			<Formik initialValues={filters} onSubmit={handleSubmit} enableReinitialize>
				{({ values, resetForm, setFieldValue }) => {
					const handleReset = () => {
						const emptyFilters = Object.fromEntries(
							Object.keys(filters).map(filterField => [filterField, []])
						);

						resetForm({ values: emptyFilters });
					};

					const handleChange = (filterField, newValue) => {
						if (onChange) {
							onChange(filterField, newValue);
						}
						setFieldValue(filterField, newValue);
					};

					return (
						<FilterDrawerForm
							isSinglePanelMode={isSinglePanelMode}
							selectedFilters={values}
							onReset={handleReset}
							onChange={handleChange}
							onApply={onApply}
						/>
					);
				}}
			</Formik>
		</Modal>
	);
};

FilterDrawer.propTypes = {
	isSinglePanelMode: PropTypes.bool,
	onSubmit: PropTypes.func,
	onApply: PropTypes.func,
	onChange: PropTypes.func,
};
